import { render, staticRenderFns } from "./Borrowings.vue?vue&type=template&id=7a44fcd5&"
import script from "./Borrowings.vue?vue&type=script&lang=js&"
export * from "./Borrowings.vue?vue&type=script&lang=js&"
import style0 from "./Borrowings.vue?vue&type=style&index=0&id=7a44fcd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports